// src/admin/components/ConfirmDialog.jsx
import React, { useState, useEffect } from 'react';
import AdminModal from './AdminModal.jsx';

export default function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = 'Conferma', variant = 'default' }) {
  const isDanger = variant === 'danger';
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  // Reset transient state every time the dialog opens
  useEffect(() => {
    if (open) { setLoading(false); setErr(''); }
  }, [open]);

  async function handleConfirm() {
    setErr('');
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch (e) {
      setErr(e?.message || 'Errore');
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    if (loading) return; // can't dismiss while a confirm is in-flight
    onClose();
  }

  return (
    <AdminModal open={open} onClose={handleClose} title={title} width={400}>
      <p style={{ color: '#3a3a3c', fontSize: '14px', margin: '0 0 16px', lineHeight: 1.5 }}>{message}</p>
      {err && (
        <div role="alert" style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '8px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444', fontSize: '13px' }}>
          {err}
        </div>
      )}
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <button
          onClick={handleClose}
          disabled={loading}
          style={{
            padding: '8px 16px', borderRadius: '8px',
            border: '1px solid rgba(0,0,0,0.1)', background: '#ffffff',
            color: '#3a3a3c', fontSize: '13px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.5 : 1,
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Annulla
        </button>
        <button
          onClick={handleConfirm}
          disabled={loading}
          style={{
            padding: '8px 16px', borderRadius: '8px', border: 'none',
            background: loading ? '#ccc' : (isDanger ? '#EF4444' : '#E8002D'),
            color: '#fff', fontSize: '13px', fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {loading ? 'Attendere…' : confirmLabel}
        </button>
      </div>
    </AdminModal>
  );
}
